import { render, staticRenderFns } from "./ViewTitle.vue?vue&type=template&id=83ecd230&scoped=true&"
import script from "./ViewTitle.vue?vue&type=script&lang=js&"
export * from "./ViewTitle.vue?vue&type=script&lang=js&"
import style0 from "./ViewTitle.vue?vue&type=style&index=0&id=83ecd230&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ecd230",
  null
  
)

export default component.exports